import { Box, Grid2, Link, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as CompletedIcon } from "Assets/Icons/Curriculum/CompletedIcon.svg";
import { ReactComponent as ForwardIcon } from "Assets/Icons/Curriculum/ForwardIcon.svg";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  margin: "auto",
  "& .outlined": {
    width: "calc(95% - 80px)",
    background: theme.palette.border.blue,
    "& .empty": {
      background: theme.palette.success.blue,
      border: `1px solid ${theme.palette.border.main}`,
      width: "20%",
      height: "4px"
    },
    "& .filled": {
      background: theme.palette.success.main,
      border: `1px solid ${theme.palette.border.blue}`,
      // width: "20%",
      height: "4px",
    },
  },
  "& .steps": {
    marginTop: "-18px",
    width: "95%",
    "&>div": {
      display: "flex",
      justifyContent: "end",
      "&>div": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& svg": {
          background: theme.palette.white.main,
          border: `2px solid ${theme.palette.border.blue}`,
          borderRadius: "50px",
          padding: "8px 4px",
        },
      },
    },
  },
});

const ModuleProgress = ({ module }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <>
      <Box sx={styles}>
        <Box className="outlined">
          {/* <Box className="filled"></Box> */}
          <Box className={'filled'} width={`${Math.ceil((20 * module.Completed) / 100)}%`}></Box>
        </Box>
        <Grid2 columns={11} container className="steps">
          <Grid2 size={2}>
            <Box>
              <PrimaryIcon height="12px" icon={module.IsCompleted ? CompletedIcon : LockIcon} color={module.IsCompleted ? "success" : "primary"} />
              <Typography fontWeight={500}>{Translation?.YourClasses}</Typography>
              <Typography color="secondary.light">{`${module.Completed}% ${Translation?.Completed}`}</Typography>
            </Box>
          </Grid2>
          <Grid2 size={3}>
            <Box>
              {/* <PrimaryIcon icon={LockIcon} height="12px" color="primary" /> */}
              <PrimaryIcon icon={ForwardIcon} height="12px" color="primary" />
              <Typography fontWeight={500}>{Translation?.SkillTestUnlocked}</Typography>
              <Typography
                component={Link}
                color="primary"
                underline="none"
                href="#"
                onClick={() => navigate(`/test/${id}`)}
              >
                {Translation?.StartTest}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={3}>
            <Box>
              <PrimaryIcon icon={LockIcon} height="12px" />
              <Typography fontWeight={500}>{Translation?.MockInterview}</Typography>
              <Typography color="secondary.light">
                {Translation?.ActivePostModuleClasses}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={3}>
            <Box>
              <PrimaryIcon icon={LockIcon} height="12px" />
              <Typography fontWeight={500}>{Translation?.InterviewerFeedback}</Typography>
              <Typography color="secondary.light">
                {Translation?.UnlocksPostYourInterview}
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default ModuleProgress;
